export const FAULT_TYPE_CUSTOMER = 'Customer';
export const FAULT_TYPE_MERCHANT = 'ANF';

export const ROOT_NAME = 'REASON_CODES';

export function normalizeName(name) {
  return name.replace(/-/g, '_').toUpperCase();
}

function getNodeFromSelection(returnReasonsTree, ...selectedOptions) {
  if (typeof returnReasonsTree !== 'object' || returnReasonsTree === null) return null;
  const filteredSelectedOptions = selectedOptions.filter((option) => typeof option === 'string');
  let currentNode = returnReasonsTree;
  let nextNode;

  for (let i = 0; i < filteredSelectedOptions.length; i += 1) {
    const option = normalizeName(filteredSelectedOptions[i]);
    nextNode = currentNode.children.find((node) => node.name === option);
    if (!nextNode) return null;
    currentNode = nextNode;
  }

  return currentNode;
}

export function getProductReturnReasonOptions(returnReasonsTree, ...selectedOptions) {
  const node = getNodeFromSelection(returnReasonsTree, ...selectedOptions);
  if (node === null) return [];
  // Return children of the current node and remove the children key
  const selection = node.children.map(({ children, ...child }) => child);
  // deduplicate the selection based on object properties
  return selection.filter((item, index, self) => (
    index === self.findIndex((t) => Object.keys(item).every((key) => item[key] === t[key]))
  ));
}

export function isSelectionValid(returnReasonsTree, ...selectedOptions) {
  const node = getNodeFromSelection(returnReasonsTree, ...selectedOptions);
  if (node === null) return false;
  return node.final === true;
}
